'use strict';

intellidealerAppCoreModule.factory('customersResource', function ($resource, appConfigurationService) {
  return {
    assignedCustomer: $resource(appConfigurationService.basePath + '/rest/security/assignedMyDealerCustomer'),
    cellCarriers: $resource(appConfigurationService.basePath + '/rest/cellcarriers/findAllActive')
  };
});
